export default __webpack_public_path__ + "static/media/mari_s.6356dadd.jpg";